




























































import CFMDialog from '@/scripts/CFMDialog'
import { Component, Vue } from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'
import CFMMultiselect from '@/components/partials/CFMMultiselect.vue'

import {required, minValue} from "vuelidate/lib/validators";

import { CFMDTOQualification, CFMDTOQualificationType } from '@/scripts/services/ClientApiAuto'

@Component<QualificationDialog>({
    components: {
        'cfm-multiselect': CFMMultiselect
    },
    validations() {
        return {
          qualification:{
              Name: {required},
              QualificationTypeId: {required},
          },
        }
    },
})
export default class QualificationDialog extends CFMDialog {
    qualification: CFMDTOQualification = {Name: ''};
    qualificationTypeList: CFMDTOQualificationType[] = [];
    
    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.qualification.qualificationGetById({id: <number>this.id});
        this.qualification = res.data;
      }
       const promises = [
        this.getQualificationTypes()
      ];
      await Promise.all(promises);
      blockui.unBlockModal();
    }

    get isUpdate() {
        return !!this.id;
    }

    async getQualificationTypes(){
      const response = await this.apiClient.qualificationType.qualificationTypeGetQualificationTypes();
      this.qualificationTypeList = response.data.map(x=>({Name:<string>x.Text, Id:<number>x.Value}));
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      
      let formData:CFMDTOQualification = {
        Id: this.qualification.Id,
        Name: this.qualification.Name,
        QualificationTypeId: this.qualification.QualificationTypeId,
        IsActive: true
      };

      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.qualification.qualificationSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
